// ============================================================
// CALENDLY — rezervační popup z administrovatelných odkazů
// Jakýkoliv odkaz s href končícím na #calendly (např. Cílová URL banneru
// v adminu) otevře Calendly widget místo navigace. URL rezervace jde ze
// shopDataLayer.calendly.url — per mutace, bez zásahu do kódu.
// Assety widgetu se dotahují lazy až při prvním kliku — mimo kontaktní
// stránky nejsou načtené.
// ============================================================

$(document).ready(function () {
    $(document).on("click", "a[href$='#calendly']", function (e) {
        e.preventDefault();

        const url = getShopDataLayer().calendly.url;
        if (!url) {
            return;
        }

        openCalendlyPopup(url);
    });
});

function openCalendlyPopup(url) {
    if (typeof Calendly !== "undefined") {
        Calendly.initPopupWidget({ url: url });
        return;
    }

    if ($("link[href='https://assets.calendly.com/assets/external/widget.css']").length === 0) {
        $("<link rel='stylesheet' href='https://assets.calendly.com/assets/external/widget.css'>").appendTo("head");
    }

    // Script už se načítá z předchozího kliku — nechat doběhnout jeho onload
    if ($("script[src='https://assets.calendly.com/assets/external/widget.js']").length > 0) {
        return;
    }

    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.onload = function () {
        Calendly.initPopupWidget({ url: url });
    };
    document.head.appendChild(script);
}
